// extracted by mini-css-extract-plugin
export default {"headingTextContainer":"HeadingText_headingTextContainer__kEO0g"};